import { getSession } from './session'
const axios = require('axios');
const service = process.env.VUE_APP_API_URL

function getHeaders() {
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getSession().token}`
  }
}

function fetchGet(name) {
  let headers = getHeaders()
  return axios.get(`${service}/${name}`, { headers }).then(response => response.data)
}

function fetchPost(name, data) {
  let headers = getHeaders()
  return axios.post(`${service}/${name}`, 
    data, {
    headers }).then(response => response.data)
}

export { fetchGet, fetchPost }